window.addEventListener('load', function() {  
    var CpfCnpjMaskBehavior = function (val) {
        return val.replace(/\D/g, "").length <= 11
            ? "000.000.000-009"
            : "00.000.000/0000-00";
    },
    cpfCnpjpOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(
                CpfCnpjMaskBehavior.apply({}, arguments),
                options
            );
        },
    };
    jQuery('input[name="document_number"], input[name="billing_address[document_number]"]').mask(
    CpfCnpjMaskBehavior,
    cpfCnpjpOptions
    );

   //--------------------------------------------------------------------------------------------
        // Telephone input mask
        var telephoneMaskBehavior = function (val) {
            return val.replace(/\D/g, "").length <= 10
                ? "(00) 0000-00009"
                : "(00) 00000-0000";
        },
        telephoneOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(
                    telephoneMaskBehavior.apply({}, arguments),
                    options
                );
            },
        };
    jQuery('input[name="telephone"], input[name="billing_address[telephone]"], .telephone').mask(
        telephoneMaskBehavior,
        telephoneOptions
    );

    // Postcode input mask
    jQuery('input[name="address[postcode]"], input[name="billing_address[postcode]"]').mask("00000-000");

});